





































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";

import Add from "./add.vue";
import Edit from "./edit.vue";

@Component({
  components: {
    Add,
    Edit
  }
})
export default class extends Mixins(MyList) {
  dispatchType: string = "oplatformapps/groups";

  dispatchTypeDelete: string = "oplatformapps/deletegroup";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "组名", dataIndex: "group_name" },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.loadData();
  }
}
